import { render, staticRenderFns } from "./Brandkit.vue?vue&type=template&id=bcb9b6aa&scoped=true&"
import script from "./Brandkit.vue?vue&type=script&lang=js&"
export * from "./Brandkit.vue?vue&type=script&lang=js&"
import style0 from "./Brandkit.vue?vue&type=style&index=0&id=bcb9b6aa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9b6aa",
  null
  
)

export default component.exports